<template>
  <v-container>
    <v-row align="center">
    </v-row>
  </v-container>

</template>

<script>
export default {
};
</script>
<style scoped>

</style>
